module.exports = __webpack_public_path__ + "img/python-logo.016c26b4.svg";